import React, { useEffect, useState } from 'react';
import Header2 from '../components/Header2';
import Footer from '../components/Footer';
import { fetchProjects } from '../services/projectService';
import { getImageUrl } from '../utils/imageUrl';
import { Loader } from './common';
import { Link } from 'react-router-dom';

const AllProjects = () => {
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [categories, setCategories] = useState(['All']);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadProjects = async () => {
            try {
                const { data } = await fetchProjects();
                setProjects(data);
                setFilteredProjects(data);

                // Extract unique categories
                const cats = ['All', ...new Set(data.map(p => p.category).filter(Boolean))];
                setCategories(cats);
            } catch (error) {
                console.error("Failed to fetch projects", error);
            } finally {
                setLoading(false);
            }
        };
        loadProjects();
        window.scrollTo(0, 0);
    }, []);

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        if (category === 'All') {
            setFilteredProjects(projects);
        } else {
            setFilteredProjects(projects.filter(p => p.category === category));
        }
    };

    return (
        <div className="home-one bg-gray-900 text-white min-h-screen">
            <Header2 />

            <section className="projects-area pt-130 rpt-100 pb-100 rpb-70 rel z-1">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            <div className="section-title text-center mb-50 wow fadeInUp delay-0-2s">
                                <span className="sub-title mb-15" style={{ color: '#38BDF8', fontWeight: 600, letterSpacing: '1px' }}>
                                    EXECUTIVE PORTFOLIO
                                </span>
                                <h2 style={{ color: '#F8FAFC', fontWeight: 800, fontSize: '38px' }}>
                                    Engineered <span>Projects & Solutions</span>
                                </h2>
                                <p style={{ color: '#94A3B8', fontSize: '16px', maxWidth: '650px', margin: '15px auto 0' }}>
                                    A showcase of production-ready applications, enterprise CRM systems, and full-stack architectures built for scalability.
                                </p>
                            </div>

                            {/* Category Filter Pills */}
                            {categories.length > 1 && (
                                <div className="d-flex flex-wrap justify-content-center gap-2 mb-5">
                                    {categories.map((cat) => (
                                        <button
                                            key={cat}
                                            onClick={() => handleCategorySelect(cat)}
                                            style={{
                                                padding: '8px 20px',
                                                borderRadius: '30px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                border: '1px solid',
                                                borderColor: selectedCategory === cat ? '#38BDF8' : 'rgba(255, 255, 255, 0.1)',
                                                backgroundColor: selectedCategory === cat ? 'rgba(56, 189, 248, 0.15)' : 'rgba(19, 27, 46, 0.6)',
                                                color: selectedCategory === cat ? '#38BDF8' : '#94A3B8',
                                                transition: 'all 0.3s ease',
                                                cursor: 'pointer',
                                                backdropFilter: 'blur(8px)'
                                            }}
                                        >
                                            {cat}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {loading ? (
                        <Loader fullScreen={false} size="lg" text="Loading enterprise projects..." />
                    ) : filteredProjects.length === 0 ? (
                        <div className="text-center py-5 text-gray-400">
                            <i className="far fa-folder-open text-4xl mb-3 d-block opacity-40"></i>
                            No projects found in this category.
                        </div>
                    ) : (
                        filteredProjects.map((project, index) => (
                            <div
                                key={project._id || index}
                                className="row align-items-center mb-5 p-4 executive-card"
                                style={{
                                    transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                                    marginBottom: '32px'
                                }}
                            >
                                <div className={`col-lg-6 ${index % 2 !== 0 ? 'order-lg-2' : ''}`}>
                                    <div
                                        className="project-image wow fadeInLeft delay-0-2s position-relative"
                                        style={{
                                            borderRadius: '16px',
                                            overflow: 'hidden',
                                            border: '1px solid rgba(255,255,255,0.1)',
                                            boxShadow: '0 15px 35px rgba(0,0,0,0.4)'
                                        }}
                                    >
                                        <img
                                            src={getImageUrl(project.img)}
                                            alt={project.title}
                                            style={{
                                                width: '100%',
                                                height: '340px',
                                                objectFit: 'cover',
                                                transition: 'transform 0.5s ease'
                                            }}
                                            className="project-img-hover"
                                        />
                                        {project.category && (
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: '16px',
                                                    left: '16px',
                                                    backgroundColor: 'rgba(11, 15, 25, 0.85)',
                                                    backdropFilter: 'blur(8px)',
                                                    color: '#38BDF8',
                                                    fontSize: '12px',
                                                    fontWeight: '700',
                                                    padding: '6px 14px',
                                                    borderRadius: '20px',
                                                    border: '1px solid rgba(56, 189, 248, 0.3)'
                                                }}
                                            >
                                                {project.category}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className={`col-xl-5 col-lg-6 ${index % 2 !== 0 ? 'ms-auto' : ''}`}>
                                    <div className="project-content wow fadeInRight delay-0-2s p-2">
                                        <div className="d-flex flex-wrap gap-2 mb-3">
                                            {project.technologies && project.technologies.map((tech, tIdx) => (
                                                <span
                                                    key={tIdx}
                                                    style={{
                                                        backgroundColor: 'rgba(56, 189, 248, 0.08)',
                                                        border: '1px solid rgba(56, 189, 248, 0.2)',
                                                        color: '#38BDF8',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        padding: '4px 12px',
                                                        borderRadius: '6px'
                                                    }}
                                                >
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>
                                        <h2 className="mb-3" style={{ fontSize: '26px', fontWeight: 800, color: '#F8FAFC' }}>
                                            <Link to={`/project-details/${project._id || project.id}`} style={{ color: '#F8FAFC', textDecoration: 'none' }}>
                                                {project.title}
                                            </Link>
                                        </h2>
                                        <p style={{ color: '#94A3B8', fontSize: '15px', lineHeight: '1.7' }}>
                                            {project.shortDesc || project.desc}
                                        </p>
                                        <div className="mt-4">
                                            <Link to={`/project-details/${project._id || project.id}`} className="btn-executive-secondary">
                                                Case Study & Architecture <i className="far fa-arrow-right ms-2"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}

                    <div className="project-btn text-center pt-3 wow fadeInUp delay-0-2s">
                        <Link to="/" className="theme-btn">
                            Back to Home <i className="far fa-angle-right ms-1"></i>
                        </Link>
                    </div>

                </div>
                <div className="bg-lines">
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                    <span></span><span></span>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default AllProjects;
